const pricingPlans = [
  {
    id: 1,
    name: "🎓 Starter Plan",
    description:
      "Essential tools to start connecting and communicating with alumni digitally.",
    features: [
      {
        id: 1,
        title: "Custom Landing Page",
        description:
          "A branded homepage tailored for your university with logo, colors, and custom messaging.",
      },
      {
        id: 2,
        title: "Noticeboard",
        description:
          "Post university announcements, reminders, achievements, and opportunities in real-time.",
      },
      {
        id: 3,
        title: "News and Stories",
        description:
          "Share alumni success stories, campus updates, and editorials to keep alumni engaged.",
      },
      {
        id: 4,
        title: "Events",
        description:
          "Create and manage alumni reunions, webinars, and college-hosted events.",
      },
      {
        id: 5,
        title: "Event RSVPs & Reminders",
        description: "Allow alumni to RSVP and receive email or SMS reminders.",
      },
      {
        id: 6,
        title: "Basic Admin Dashboard",
        description:
          "Access a simple dashboard to manage content, events, and users.",
      },
      {
        id: 7,
        title: "Email Support",
        description:
          "Get assistance via email with a 24–48 hour response time.",
      },
    ],
  },
  {
    id: 2,
    name: "🏛️ Engage Plan",
    description:
      "Expand alumni interaction with networking, and private messaging tools.",
    features: [
      {
        id: 1,
        title: "Batchmates Directory",
        description:
          "Filter alumni by batch year, department, or program for easy reconnection.",
      },
      {
        id: 2,
        title: "Advanced Alumni Profiles",
        description:
          "Alumni can add photos, work history, social links, and bios.",
      },
      {
        id: 3,
        title: "Verified Alumni Database",
        description:
          "Manage and verify alumni identities securely to maintain data integrity.",
      },
      {
        id: 4,
        title: "Alumni Search Functionality",
        description: "Search alumni by name, location, company, or industry.",
      },
      {
        id: 5,
        title: "Messaging Center",
        description:
          "One-on-one and group messaging within the platform for easy communication.",
      },
      {
        id: 6,
        title: "Event Participation Insights",
        description:
          "View which alumni attend your events and track engagement history.",
      },
      {
        id: 7,
        title: "Moderation Tools",
        description:
          "Control over posts, comments, and user-generated content.",
      },
      {
        id: 8,
        title: "Priority Email Support",
        description:
          "Faster response times and dedicated assistance via email.",
      },
    ],
  },
  {
    id: 3,
    name: "🌐 Legacy Plan",
    description:
      "Full-featured alumni platform with career growth and mentorship tools.",
    features: [
      {
        id: 1,
        title: "Careers Portal",
        description:
          "Alumni can post jobs or internships and apply directly within the platform.",
      },
      {
        id: 2,
        title: "Job Matching Tools",
        description:
          "Recommend job listings to alumni based on their profiles or interests.",
      },
      {
        id: 3,
        title: "Resume Upload & Visibility",
        description:
          "Alumni can upload resumes to be discovered by peers and recruiters.",
      },
      {
        id: 4,
        title: "Mentorship Program Builder",
        description:
          "Create structured mentorship programs with mentor-mentee matching and tracking.",
      },
      {
        id: 5,
        title: "Mentor Profiles & Feedback",
        description:
          "Detailed mentor profiles with reviews and feedback from mentees.",
      },
    ],
  },
];

export default pricingPlans;
